"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _templateObject;
var getPersonQuery = (0, _graphqlTag.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  query ClientGetPerson {\n    person {\n      id\n      name\n      personStatusId\n      email\n      roles(status: [ACTIVE, DISAPPROVED, PENDING_APPROVE, PENDING_AUTHENTICITY_CONFIRMATION]) {\n        id\n        name\n      }\n      schools {\n        id\n        legalName\n      }\n    }\n  }\n"])));
var profileEndpoint = function profileEndpoint(client) {
  return {
    get: function () {
      var _get = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(customPersonQuery) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", client.graphqlClient.query({
                query: customPersonQuery || getPersonQuery
              }).then(function (_ref) {
                var data = _ref.data;
                return data.person;
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function get(_x) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  };
};
var _default = profileEndpoint;
exports.default = _default;